import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import {
	BidderDomainCounter,
	CampaignDomainTagCounters,
	ICampaignConflictData,
	ICampaignDomainStateCacheRequest,
	ICampaignDomainStateRequest,
	ICampaignDomainStateResponse,
} from '../models/bidder-domains.model';

export const BidderDomainsApi = {
	getCampaignDomainTagCounters: (): Promise<{ campaign_domain_tag_counters: CampaignDomainTagCounters[] }> => {
		return ask.get(endpoints.bidderDomains.getCampaignDomainTagCounters());
	},

	getNotWorkingDomainCounters: (): Promise<{ campaign_not_working_domain_counters: BidderDomainCounter[] }> => {
		return ask.get(endpoints.bidderDomains.getNotWorkingDomainCounters());
	},

	getCampaignTrashDomainCounters: (): Promise<{ campaign_trash_domain_counters: BidderDomainCounter[] }> => {
		return ask.get(endpoints.bidderDomains.getCampaignTrashDomainCounters());
	},

	getCampaignDomainStatus: (request: ICampaignDomainStateRequest): Promise<ICampaignDomainStateResponse> => {
		return ask.post(endpoints.bidderDomains.getCampaignDomainStatus(), request);
	},

	getDomainStatuses: async (): Promise<string[]> => {
		const response = (await ask.get(endpoints.bidderDomains.getDomainStatuses())) as
			| { domainStatuses?: { name?: string; custom?: boolean }[] }
			| undefined;
		const items = response?.domainStatuses;
		if (!Array.isArray(items)) {
			return [];
		}
		return items.map(item => item?.name).filter((name): name is string => Boolean(name));
	},

	getCampaignConflictData: (campaignId: id): Promise<{ campaign_conflict_data: ICampaignConflictData }> => {
		return ask.get(endpoints.bidderDomains.getCampaignConflictData(campaignId));
	},

	download(pathname: string) {
		return ask.download(endpoints.bidderDomains.download(pathname));
	},

	downloadCampaignConflictData(id: number, secondId: number) {
		return ask.download(endpoints.bidderDomains.downloadCampaignConflictData(id, secondId));
	},

	openClosedDomain: (request: ICampaignDomainStateCacheRequest): Promise<ICampaignDomainStateResponse> => {
		return ask.post(endpoints.bidderDomains.openClosedDomain(), request);
	},

	deleteDomainCampaignCache: (request: ICampaignDomainStateCacheRequest): Promise<ICampaignDomainStateResponse> => {
		return ask.post(endpoints.bidderDomains.deleteDomainCampaignCache(), request);
	},
};
